import { render, staticRenderFns } from "./pie-rose.vue?vue&type=template&id=04bf8ac2&"
import script from "./pie-rose.vue?vue&type=script&lang=js&"
export * from "./pie-rose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports